import React from 'react'
import { GraviButton, Horizontal, Texto } from '@gravitate-js/excalibrr'
import { CloseOutlined, CommentOutlined } from '@ant-design/icons'
import { Popconfirm, Tooltip } from 'antd'
import { useWizardMaster } from '@components/OrderWizard/Contexts/WizardMasterContext'
import { useSecurityContext } from '@components/Navigation/SecurityContext'

export const NotePreview = ({ note, allowNoteEdit, onConfirm, onEdit, className }) => {
  return (
    <Horizontal
      style={{ minHeight: 'fit-content' }}
      bg='elevated'
      border='all'
      verticalCenter
      borderRadius={4}
      className={`p-2 mb-3 ${className}`}
    >
      <div className='flex items-center'>
        <Texto>
          <CommentOutlined className='ml-2 mr-3 comment-icon' />
        </Texto>
        <Texto category='h6' weight='bold'>
          Driver Note:
        </Texto>
      </div>
      <div className='flex items-center flex-1'>
        <Texto className=' ml-4'>{note}</Texto>
      </div>
      <div className='flex items-center'>
        {allowNoteEdit && <GraviButton size='small' buttonText='Edit Note' className='mr-4' onClick={onEdit} />}
        <Tooltip title={<Texto appearance='light'>Remove Note</Texto>}>
          <Popconfirm
            title={`Are you sure you want to remove the driver's note?`}
            onConfirm={onConfirm}
            okText='Yes'
            cancelText='No'
          >
            {allowNoteEdit && (
              <GraviButton size='small' icon={<CloseOutlined />} appearance='outline' className='remove-note mr-1' />
            )}
          </Popconfirm>
        </Tooltip>
      </div>
    </Horizontal>
  )
}

export const DriverNotePreview = () => {
  const { driverNote, setViewingNoteForm, form, setDriverNote } = useWizardMaster()
  const { scopes } = useSecurityContext()
  const canViewNote = scopes.config.notes_enabled
  const allowNoteEdit = scopes.scopes.includes('o.w')

  if (!canViewNote) return null
  const confirmNoteRemoval = () => {
    setDriverNote(undefined)
    form.setFieldsValue({ content: undefined })
  }

  return (
    <NotePreview
      note={driverNote}
      allowNoteEdit={allowNoteEdit}
      onConfirm={confirmNoteRemoval}
      onEdit={() => setViewingNoteForm(true)}
    />
  )
}
